@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

$action-types: (
  'submodel' $color-action-submodel,
  'previous' $color-action-back,
  'exit' $color-action-exit,
  'snippet' $color-action-snippetenabled,
  'defaultAction' $theme-color-button-remove-chip
);

.ActionTypeIndicator {
  @extend %font-family-primary;

  color: $color-white;
  display: flex;
  padding: 12px 4px;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;

  @each $name, $color in $action-types {
    &.#{$name} {
      background: $color;
    }
  }

  svg {
    font-size: 16px;
  }
}
